import { render, staticRenderFns } from "./FormHolder.vue?vue&type=template&id=111e341c&"
import script from "./FormHolder.vue?vue&type=script&lang=js&"
export * from "./FormHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports